var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext } from 'react';
import moment from 'moment';
import Input from '../../Forms/Input';
import { LanguageContext } from '../../ThemeProvider/ThemeProvider';
import SpaceAroundWrap from '../SpaceAround';
import DatetimePicker from './Datetime/DateTime';
import { x } from '@xstyled/styled-components';
// @TODO each language has 62kb gziped, please replace moment with different lib
import 'moment/dist/locale/cs';
import 'moment/dist/locale/el';
import 'moment/dist/locale/it';
import 'moment/dist/locale/ru';
import 'moment/dist/locale/sk';
import { DatePickerBase } from './styles';
var defaultDateFormat = 'DD.MM.YYYY';
var DatePicker = function (_a) {
    var name = _a.name, value = _a.value, initialViewDate = _a.initialViewDate, error = _a.error, label = _a.label, disabled = _a.disabled, isValidDate = _a.isValidDate, onChange = _a.onChange, _b = _a.dateFormat, dateFormat = _b === void 0 ? defaultDateFormat : _b, _c = _a.timeFormat, timeFormat = _c === void 0 ? false : _c, open = _a.open, _d = _a.secondValue, secondValue = _d === void 0 ? null : _d, input = _a.input, _e = _a.icon, icon = _e === void 0 ? true : _e, _f = _a.showInputLabel, showInputLabel = _f === void 0 ? false : _f, _g = _a.showCalendarLabel, showCalendarLabel = _g === void 0 ? true : _g, _h = _a.spaceAround, spaceAround = _h === void 0 ? false : _h, className = _a.className, onClear = _a.onClear, onInputChange = _a.onInputChange, passProps = __rest(_a, ["name", "value", "initialViewDate", "error", "label", "disabled", "isValidDate", "onChange", "dateFormat", "timeFormat", "open", "secondValue", "input", "icon", "showInputLabel", "showCalendarLabel", "spaceAround", "className", "onClear", "onInputChange"]);
    var format = "".concat(dateFormat).concat(timeFormat ? " ".concat(timeFormat) : "");
    var isValid = !!value && moment(value, format, true).isValid();
    var stringValue = isValid ? moment(value, format).format(format) : value;
    var locale = useContext(LanguageContext);
    var handleRenderInput = useCallback(function (_, openCalendar) {
        return (_jsx(Input, { type: "text", icon: icon ? 'calendar' : undefined, name: name, error: error, disabled: disabled, isInvalid: !!error, onChange: onInputChange, label: showInputLabel ? label : undefined, value: stringValue, onFocus: openCalendar, iconOnClick: openCalendar, onClear: onClear, autoComplete: "off" }));
    }, [name, stringValue, error, label, showInputLabel, isValid, disabled]);
    var handleRenderView = useCallback(function (_, renderCalendar) {
        if (label && !showInputLabel) {
            return (_jsx(x.div, { display: "flex", flexDirection: "column", children: renderCalendar() }));
        }
        return renderCalendar();
    }, [label, showInputLabel]);
    var handleChange = useCallback(function (value) {
        var parsed = typeof value === 'string' ? value : value.toDate();
        onChange === null || onChange === void 0 ? void 0 : onChange(parsed);
    }, [onChange]);
    var handleIsValid = useCallback(function (current, selected) {
        var _a, _b;
        var parsed = [(_a = current === null || current === void 0 ? void 0 : current.toDate) === null || _a === void 0 ? void 0 : _a.call(current), (_b = selected === null || selected === void 0 ? void 0 : selected.toDate) === null || _b === void 0 ? void 0 : _b.call(selected)];
        return isValidDate ? isValidDate.apply(void 0, parsed) : true;
    }, [isValidDate]);
    return (_jsx(SpaceAroundWrap, { spaceAround: spaceAround, children: _jsx(DatePickerBase, { className: className, children: _jsx(DatetimePicker, __assign({ value: value, dateFormat: dateFormat, timeFormat: timeFormat, secondValue: secondValue, open: open, input: input, label: showCalendarLabel ? label : undefined, onChange: handleChange, isValidDate: handleIsValid, renderView: handleRenderView, renderInput: handleRenderInput, initialViewDate: initialViewDate, locale: locale }, passProps)) }) }));
};
export default React.memo(DatePicker);
